export default function ErrorPage() {
  return (<h1>404 page</h1>)
}
